import { Input } from "@headlessui/react";
import clsx from "clsx";

export default function InputFieldDecimal({
  placeholder,
  errorMsg,
  disabled,
  name,
  id,
  ref,
  className,
  type = "text",
  value,
  onChange,
  ...restProps
}) {
  // Only apply formatting if type is number or text and decimals are needed
  const handleChange = (e) => {
    let val = e.target.value;
    // Allow empty value
    if (val === "") {
      onChange && onChange(e);
      return;
    }
    // Only allow numbers and decimals
    if (/^\d*\.?\d*$/.test(val)) {
      // Format to 2 decimals if there's a decimal point
      if (val.includes(".")) {
        const [int, dec] = val.split(".");
        val = int + "." + dec.slice(0, 2);
      }
      // Create a synthetic event to pass the formatted value up
      const event = {
        ...e,
        target: {
          ...e.target,
          value: val,
        },
      };
      onChange && onChange(event);
    }
  };

  return (
    <Input
      className={({ disabled }) =>
        clsx(
          disabled && "tw-bg-disabled-bg-light tw-text-disabled-text",
          errorMsg && "tw-ring-2 tw-border-none tw-outline-none tw-ring-error-light",
          "tw-border tw-border-boarder-light tw-py-1 tw-px-2 tw-h-9 tw-rounded-md tw-text-text-primary-light",
          "tw-focus:outline-none tw-focus:border-none tw-focus:ring-2 ",
          errorMsg ? " tw-focus:ring-error-light" : " tw-focus:ring-focus",
          className
        )
      }
      placeholder={placeholder}
      disabled={disabled}
      ref={ref}
      value={value}
      onChange={type === "number" || type === "text" ? handleChange : onChange}
      onKeyDown={(e) => {
        if (type !== "text" && (e.key === "e" || e.key === "E")) {
          e.preventDefault();
        }
      }}
      inputMode="decimal"
      pattern="^\d+(\.\d{0,2})?$"
      type={type}
      name={name}
      id={name}
      {...restProps}
    />
  );
}